<template>
<div class="chapter">
<div class="inner_page">
<div class="bgpart">
<h2 class="h2"><a id="page_1"></a><a id="pt1"></a><strong>PART ONE<br/><br/>BIG DOGS AND GUERRILLAS—AN INTRODUCTION TO GUERRILLA DEAL-MAKING</strong><a id="page_2"></a></h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?028f18e3